import {EditorSelection} from "@codemirror/state";

import {blank} from "./trim.js";

export function appendMarkdown(state, string) {
  return appendMarkdownLineFeed(state, string.replaceAll('\r', ''));
}

function appendMarkdownLineFeed(state, string) {
  if (contentBlank(state)) {
    return reset(state, string);
  }
  return append(state, padding(state) + closingCodePadding(state) + "\n" + string);
}

function contentBlank(state) {
  if (firstCharactersBlank(state)) {
    return blank(state.doc.toString());
  }
  return false;
}

function firstCharactersBlank(state) {
  return blank(state.sliceDoc(0, Math.min(9, state.doc.length - 1)));
}

function append(state, content) {
  return {
    changes: [{from: state.doc.length, insert: content}],
    selection: EditorSelection.single(state.doc.length + content.length)
  };
}

function reset(state, content) {
  return {
    changes: [{from: 0, to: state.doc.length, insert: content}],
    selection: EditorSelection.single(content.length)
  };
}

function closingCodePadding(state) {
  const mark = unclosedCodeMark(state);
  if (mark) {
    return mark + "\n";
  }
  return '';
}

function unclosedCodeMark(state) {
  const lastChild = state.tree.topNode.lastChild;
  if (lastChild.type.name === 'FencedCode') {
    const codeMarks = lastChild.getChildren('CodeMark');
    if (codeMarks.length > 1) {
      return null;
    }
    const [codeMark] = codeMarks;
    if (codeMark) {
      return state.sliceDoc(codeMark.from, codeMark.to);
    }
  }
  return null;
}

function padding(state) {
  if (blank(lastLine(state))) {
    return "";
  }
  return "\n";
}

function lastLine(state) {
  return state.doc.lineAt(state.doc.length).text;
}
